import { render, staticRenderFns } from "./TrendingTopic.vue?vue&type=template&id=da0b6380&scoped=true&"
import script from "./TrendingTopic.vue?vue&type=script&lang=js&"
export * from "./TrendingTopic.vue?vue&type=script&lang=js&"
import style0 from "./TrendingTopic.vue?vue&type=style&index=0&id=da0b6380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0b6380",
  null
  
)

export default component.exports